import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";
import LocalStorageService from "../../common/services/LocalStorageService";

export const getPatients = createAsyncThunk(
  "get_patients",
  async (params, { rejectWithValue, getState }) => {
    try {
      if (!getState()?.auth?.isAuthenticated) {
        let count = LocalStorageService?.get("search_count") || 0;
        if (count < 7) {
          LocalStorageService?.set("search_count", count + 1);
        }
      }
      const data = await axiosClient.get(
        `${config.API_URL}/patients/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const postPatient = createAsyncThunk(
  "post_patient",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/patients/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const upvotePatient = createAsyncThunk(
  "upvote_patient",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/upvotes/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);